import { IPromise } from 'angular';
import * as React from 'react';

import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';
import { ModalInstance, ReactModalOptions, ReactModalService } from '../../../ts/services/ReactModalService';

const DIALOG_WIDTH = 400;
const ACTION_DIALOG_TESTID = 'confirm-drag-order-dialog';

export namespace ConfirmDragDropOrderDialog {

  export const RESULT_CONFIRM = 'confirm';
  export const RESULT_CANCEL = 'cancel';

  const Header = cssClass(ACTION_DIALOG_TESTID, 'header', {
    fontSize: '20px',
    lineHeight: 'normal',
    paddingBottom: 6
  });

  const Contents  = () => {
    return (
      <>
        <div className={Header}>
          {Messages.orderFavoritesConfirmDialogTitle()}
        </div>
        <div>{Messages.orderFavoritesConfirmDialogMessage()}</div>
      </>
    );
  };

  interface FooterProps {
    onCancel: () => void;
    onOk: () => void;
  }
  const Footer = (props: FooterProps) => {
    return <DialogFooterButtonsWidget
        buttons={[
          {
            handleClick: props.onCancel,
            buttonType: ButtonType.Outline,
            children: Messages.cancel(),
            testId: `${ACTION_DIALOG_TESTID}-cancel`,
          },
          {
            handleClick: props.onOk,
            buttonType: ButtonType.Primary,
            children: Messages.orderFavoritesConfirmDialogConfirm(),
            testId: `${ACTION_DIALOG_TESTID}-ok`,
          },
        ]}
        testId={`${ACTION_DIALOG_TESTID}-footer`}
      />;
  };

  export function Options(onCancel: () => void, onOk: () => void): ReactModalOptions {
    return {
      title: Messages.orderFavoritesConfirmDialogTitle(),
      testId: ACTION_DIALOG_TESTID,
      type: DialogType.NormalWithoutTitleBar,
      showCloseButton: false,
      positioningBehavior: DialogPositioningBehavior.Centered,
      dialogWidth: DIALOG_WIDTH,
      dialogBodyStyle: { maxWidth: DIALOG_WIDTH + 'px' },
      dialogContent: <Contents />,
      dialogContentStyle: { padding: CommonStyles.Sizes.MediumSpace },
      footerContent: <Footer onCancel={onCancel} onOk={onOk}/>
    };
  }

  export function open(): IPromise<any> {
    let modalInstance: ModalInstance;

    const onCancel = (): void => {
      modalInstance && modalInstance.close(RESULT_CANCEL);
    };
    const onOk = (): void => {
      modalInstance && modalInstance.close(RESULT_CONFIRM);
    };

    modalInstance = ReactModalService.open(Options(onCancel, onOk));
    return modalInstance.result;
  }
}
